import styled from 'styled-components';

import { StyleColor, BaseStyledComponentProps } from '../../utils/styles-constants';
import { hexToRgba, overlayAnimation, isSupportingBackdropBlur } from '../../utils/style';

interface OverlayProps {
	isOpen: boolean;
}

interface ButtonCancelProps extends BaseStyledComponentProps {
	color?: string;
}

interface ButtonConfirmProps extends BaseStyledComponentProps {
	disabled: boolean;
	color?: string;
}

const Overlay = styled('div')`
	position: fixed;
	top: 0;
	bottom: 0;
	left: 0;
	right: 0;
	z-index: 100;
	background: ${isSupportingBackdropBlur()
		? hexToRgba(StyleColor.White, 50)
		: hexToRgba(StyleColor.Black, 90)};
	${(props: OverlayProps) => overlayAnimation(props.isOpen)};
`;

const OverlayBlur = styled('div')`
	${isSupportingBackdropBlur() ? 'backdrop-filter: blur(20px);' : ''}
	display: flex;
	align-items: center;
	justify-content: center;
	width: 100%;
	height: 100%;
`;

const PopupContainer = styled('div')`
	box-sizing: border-box;
	width: calc(100% - 20px);
	max-width: 480px;
	border-radius: 13px;
	background-color: ${StyleColor.White};
	box-shadow: 0 3px 35px 0 ${hexToRgba(StyleColor.Black, isSupportingBackdropBlur() ? 20 : 50)};
`;

const PopupHeader = styled('div')`
	box-sizing: border-box;
	position: relative;
	padding: 20px;
	border-bottom: 2px solid ${StyleColor.Grey100};
`;

const getButtonCommonStyles = (color: string) => `
	padding: 0;
	border: 0;
	outline: 0;
	background-color: ${StyleColor.White};
	font-family: HelveticaNeue, sans-serif;
	font-weight: 500;
	font-size: 16px;
	line-height: 20px;
	color: ${color};
	letter-spacing: 0.5px;
	cursor: pointer;
`;

const ButtonCancel = styled('button')`
	${(props: ButtonCancelProps) => getButtonCommonStyles(props.color || props.theme.primary.actionColor)}
	position: absolute;
	top: 19px;
	left: 15px;
`;

const ButtonConfirm = styled('button')`
	${(props: ButtonConfirmProps) => getButtonCommonStyles(props.color || props.theme.primary.actionColor)}
	position: absolute;
	top: 19px;
	right: 15px;

	${(props: ButtonConfirmProps) => props.disabled && `
		cursor: default;
		opacity: 0.5;
	`}
`;

const PopupBody = styled('div')`
	box-sizing: border-box;
	font-family: HelveticaNeue, sans-serif;
	font-size: 16px;
	line-height: 20px;
	color: ${StyleColor.Black};
`;

const Label = styled('span')`
	display: block;
	font-family: HelveticaNeue, sans-serif;
	font-weight: 500;
	font-size: 18px;
	line-height: 20px;
	color: ${StyleColor.Black};
	text-align: center;
`;

const PopupFooter = styled('div')`
	padding: 20px;
	border-top: 2px solid ${StyleColor.Grey100};
	display: flex;
	align-items: center;
	justify-content: center;
`;

const ButtonAccept = styled('button')`
	${(props: BaseStyledComponentProps) => getButtonCommonStyles(props.theme.primary.actionColor)}
`;

export {
	Overlay,
	OverlayBlur,
	PopupContainer,
	PopupHeader,
	ButtonCancel,
	ButtonConfirm,
	PopupBody,
	Label,
	PopupFooter,
	ButtonAccept,
};



// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/components/Popup/styles.ts